import request from '@/utils/request'

// 获取商品分类列表
export function getCategoryList() {
    return request({
        url: '/admin/goodsCategory/list',
        method: 'get'
    })
}

// 分页查询分类
export function getCategoryPage(data) {
    return request({
        url: '/admin/goodsCategory/page',
        method: 'post',
        data: data
    })
}

// 新增分类
export function insertCategory(data) {
    return request({
        url: '/admin/goodsCategory/insert',
        method: 'post',
        data: data
    })
}

// 修改分类
export function updateCategory(data) {
    return request({
        url: '/admin/goodsCategory/update',
        method: 'post',
        data: data
    })
}

// 删除分类
export function deleteCategory(id) {
    return request({
        url: '/admin/goodsCategory/delete?id=' + id,
        method: 'get'
    })
}

// 启用分类列表（供 list-with-sku.vue / category.vue 引用）
export function listEnabledCategories() {
    return request({
        url: '/admin/goodsCategory/list',
        method: 'get'
    })
}
